/* eslint no-param-reassign: ["error", { "props": false }] */

import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import store from '@/store';

// store.commit('setToken', '');

const axiosClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

/**
 * リクエスト インターセプター
 */
axiosClient.interceptors.request.use((config: AxiosRequestConfig) => {
  if (config.headers !== undefined) {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }
  return config;
});
export default axiosClient;
